import BaseMoney from './BaseMoney.vue';

export default BaseMoney;